import styled from 'styled-components'
import { Video } from '../Video/Video'

export const RectangleVideo = styled(Video)`
  aspect-ratio: 3/2;
`
